<template>
  <BaseDetailLayout :title="`Order Details`">
    <template #detail>
      <div>
        <v-row class="overflow-y-auto ma-0 pt-2" style="height: calc(100vh - 140px)">
          <v-col cols="12" md="4" lg="4">
            <v-row v-if="orderDetails">
              <v-col class="pt-4">
                <div class="d-flex flex-column">
                  <v-card
                    color="secondary"
                    class="rounded-lg card-box-shadow mb-2"
                    elevation="0"
                  >
                    <v-card-title class="px-2 py-2">
                      <v-row no-gutters class="pa-2">
                        <v-col cols="12">
                          <div>
                            <h4 class="white--text">Execution Date</h4>
                            <h2
                              class="white--text"
                              v-if="orderDetails.execution_date"
                            >
                              {{ orderDetails.execution_date }}
                            </h2>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <v-divider class="mx-3" dark></v-divider>
                    <v-row class="pa-3">
                      <v-col cols="6">
                        <CompanyDetailsSmallCard
                          :text="orderDetails.reference_number"
                          textValue="Order ID"
                        />
                      </v-col>
                      <v-col cols="6">
                        <CompanyDetailsSmallCard
                          :text="orderDetails.verbose_status"
                          textValue="Order Status"
                        />
                      </v-col>
                    </v-row>
                  </v-card>
                  <!-- 
              <v-expand-transition>
                <v-card
                  elevation="0"
                  class="card-box-shadow pa-4 w-100 background_color"
                  style="border-radius: 10px"
                >
                  <div>
                    <v-row
                      class="orange lighten-5"
                      style="transition: all 0.3s ease"
                    >
                      <v-col
                        cols="2"
                        class="text-center d-flex algin-center justify-center"
                      >
                        <v-icon color="orange darken-1">mdi-information</v-icon>
                      </v-col>
                      <v-col cols="10">
                        <h5 class="mb-1 text-capitalize">
                          Order delayed by 2 hour
                        </h5>
                        <h6 class="font-weight-light">
                          Delayed Delivery order late. Delayed Delivery order
                          late. Delayed Delivery order late. Delayed Delivery
                          order late. Delayed Delivery order late. Delayed
                          Delivery order late.
                        </h6>
                      </v-col>
                    </v-row>
                  </div>
                </v-card>
              </v-expand-transition> -->

                  <v-card elevation="0" class="my-4">
                    <v-row
                      no-gutters
                      v-if="orderDetails.driver_details"
                      class="pa-2"
                    >
                      <v-col
                        cols="12"
                        md="3"
                        lg="3"
                        class="pa-5 d-flex justify-center"
                        v-if="orderDetails.driver_details.profile_image"
                      >
                        <div>
                          <v-img
                            height="50"
                            width="50"
                            class="rounded-circle"
                            contain
                            :src="orderDetails.driver_details.profile_image"
                          />
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        lg="4"
                        class="pa-5 d-flex justify-center"
                        v-else
                      >
                        <div>
                          <v-img
                            height="50"
                            width="50"
                            class="rounded-circle"
                            contain
                            :src="driverImage"
                          />
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        md="7"
                        lg="8"
                        class="py-2 d-flex align-center"
                      >
                        <div>
                          <h4 class="primary--text">Driver</h4>
                          <h4 v-if="orderDetails">
                            <BaseTooltip
                              title="full name"
                              :text="orderDetails.driver_details.full_name"
                            />
                          </h4>
                        </div>
                      </v-col>
                      <v-col cols="12 px-12">
                        <v-row no-gutters class="pb-4">
                          <v-col
                            cols="6"
                            v-if="orderDetails.driver_details.contact_number"
                          >
                            <div class="d-flex align-center">
                              <v-icon class="mr-2">mdi-truck</v-icon>
                              <h5 class="primary--text lighten-3">Vehicle</h5>
                            </div>
                            <div>
                              <h5 class="py-2">
                                {{ orderDetails.driver_details.vehicle }}
                              </h5>
                            </div>
                          </v-col>
                          <v-col
                            cols="6"
                            v-if="orderDetails.driver_details.contact_number"
                          >
                            <div class="d-flex align-center">
                              <v-icon class="mr-2">mdi-phone</v-icon>
                              <h5 class="primary--text lighten-3">
                                Contact Number
                              </h5>
                            </div>
                            <div>
                              <h5 class="py-2">
                                {{ orderDetails.driver_details.contact_number }}
                              </h5>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="4" lg="4" class="d-flex flex-column">
            <v-card
              class="rounded-lg card-box-shadow py-2 mb-5"
              elevation="0"
              ref="orderTrackingElement"
              id="orderTracking-logs-target"
            >
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="6">
                    <h6>Order Logs</h6>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text
                class="overflow-y-auto"
                style="height: calc(100vh - 620px)"
              >
                <Logs
                  :logs="orderLogs"
                  v-if="orderLogs && orderLogs.length > 0"
                />
              </v-card-text>
            </v-card>
            <v-card class="rounded-lg pa-2 h-100" elevation="0">
              <GoogleMap
                :hasMapInfo="false"
                mapHeight="350px"
                style="width: 100%"
                ref="orderMap"
              />
            </v-card>
          </v-col>

          <v-col cols="12" md="4" lg="4" class="d-flex flex-column">
            <v-card
              class="rounded-lg card-box-shadow mb-3 py-2"
              elevation="0"
              ref="orderDetailsElement"
            >
              <v-card-title class="px-3 py-1">
                <v-row no-gutters>
                  <v-col cols="6">
                    <h6>Order Details</h6>
                  </v-col>
                  <v-col cols="6" class="d-flex justify-end">
                    <PrimaryButton
                      id="ordersPOD"
                      :x-small="$vuetify.breakpoint.xs"
                      :small="true"
                      v-if="orderDetails.is_pod_uploaded"
                      btnClass="ma-1 rounded-lg"
                      @click="getConsigneeOrderAttachment(orderDetails.id)"
                      icon="mdi-file-pdf-box"
                      name="POD"
                    />
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>

              <v-card-subtitle>
                <div
                  v-if="orderDetails"
                  style="height: calc(100vh - 650px)"
                  class="overflow-y-auto"
                >
                  <div v-for="(value, key, index) in orderDetails" :key="index">
                    <v-row
                      no-gutters
                      class="px-2 py-1"
                      v-if="
                        value &&
                        [
                          'reference_number',
                          'execution_date',
                          'id',
                          'segment',
                          'status',
                          'customer_code',
                          'customer_address',
                          'driver_details',
                          'vehicle_number',
                          'driver_contact_number',
                          'driver_name',
                          'coordinates',
                          'driver_last_location',
                        ].indexOf(key) == -1
                      "
                    >
                      <v-col cols="5">
                        <h5
                          class="text-caption text-capitalize"
                          v-if="key == 'verbose_status'"
                        >
                          Status
                        </h5>
                        <h5 v-else class="text-caption text-capitalize">
                          {{ key.replace(/_/g, " ") }}
                        </h5>
                      </v-col>
                      <v-col cols="7">
                        <h4 class="text_color--text text-capitalize">
                          {{ value }}
                        </h4>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card-subtitle>
            </v-card>

            <v-card
              class="rounded-lg card-box-shadow py-2 h-100 mt-2"
              elevation="0"
              v-if="itemList"
            >
              <v-card-title class="px-2 py-0">
                <v-row no-gutters class="px-2 pb-2">
                  <v-col cols="2" class="d-flex justify-center"> # </v-col>
                  <v-col cols="8">
                    <h6 class="font-weight-bold text-black">
                      Item Description
                    </h6>
                  </v-col>
                  <v-col cols="2">
                    <span class="text-body-2 font-weight-bold">Quantity</span>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-subtitle
                style="height: 310px"
                class="overflow-y-auto"
              >
                <v-row
                  no-gutters
                  v-for="(item, index) in itemList"
                  :key="index"
                  class="pa-2"
                >
                  <v-col cols="2" class="d-flex justify-center">
                    {{ index + 1 }}
                  </v-col>
                  <v-col cols="8">
                    {{ item.description }}
                  </v-col>
                  <v-col cols="2" class="d-flex justify-center">
                    {{ item.original_quantity }}
                  </v-col>
                </v-row>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </template>
  </BaseDetailLayout>
</template>
<script>
import Logs from "@/components/BaseComponents/Logs.vue";
import BaseSmallTripDetail from "@/components/BaseComponents/BaseSmallTripDetail.vue";
import CompanyDetailsSmallCard from "@/components/ModuleBasedComponents/Company/CompanyDetailsSmallCard.vue";
import TripTooltipWithIcon from "@/components/ModuleBasedComponents/Trip/TripTooltipWithIcon.vue";
import { bus } from "@/main";
import CancelOrderForm from "@/components/ModuleBasedComponents/Order/CancelOrderForm.vue";
import RescheduleOrderForm from "@/components/ModuleBasedComponents/Order/RescheduleOrderForm.vue";
import CustomerLocationUpdateDialog from "@/components/ModuleBasedComponents/CustomerAddress/CustomerLocationUpdateDialog.vue";
import driverImage from "@/assets/profile.jpg";
import { configurationModule } from "@/utils/moduleMapping";
import BaseTooltip from "@/components/BaseComponents/BaseTooltip.vue";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import BaseDetailLayout from "@/components/LayoutComponents/BaseDetailLayout.vue";

export default {
  components: {
    GoogleMap,
    Logs,
    BaseSmallTripDetail,
    CompanyDetailsSmallCard,
    TripTooltipWithIcon,
    CancelOrderForm,
    RescheduleOrderForm,
    CustomerLocationUpdateDialog,
    BaseTooltip,
    BaseDetailLayout,
  },
  data() {
    return {
      configurationModule,
      driverImage,
      orderDeliveryDetails: {
        order_details: {
          estimated_delivery_date_time: "01/01/2023, 12:42pm",
          order_delivered_date: "01/01/2023, 01:00pm",
          order_id: "ORD00030609",
          order_status: "Unassigned",
        },
      },
      orderDetails: {},
      itemList: [],
      deliveryPartnerInfo: {
        delivery_partner_info: {
          driver_name: "Ajaykumar Prajapati",
          vehicle: "GJ-01-MX-8789",
          driver_contact_no: "+91 8927145632",
          driver_profile: "",
        },
      },
      orderLogs: [],
    };
  },
  methods: {
    setOrderLocationOnMap(orderDetails) {
      if (orderDetails && orderDetails.coordinates) {
        this.$refs.orderMap.initMap();

        const interval = setInterval(async () => {
          if (window.google && window.google.maps && this.$refs.orderMap) {
            clearInterval(interval);
            this.$refs.orderMap.clearMarker();

            if (
              orderDetails &&
              orderDetails.coordinates &&
              orderDetails.coordinates.latitude &&
              orderDetails.coordinates.longitude
            ) {
              let data = {
                title: "order details",
                address: orderDetails?.address,
                coordinates: orderDetails.coordinates,
                reference_number: orderDetails?.reference_number,
              };

              this.$refs.orderMap.setCustomMaker(
                { ...data, icon: "drop_order" },
                "destination"
              );
            }

            if (
              orderDetails &&
              orderDetails.driver_last_location &&
              orderDetails.driver_last_location.coordinates &&
              orderDetails.driver_last_location.coordinates.latitude &&
              orderDetails.driver_last_location.coordinates.longitude
            ) {
              this.$refs.orderMap.setCustomMaker(
                {
                  title: "driver details",
                  ...orderDetails.driver_last_location,
                  icon: "driver",
                },
                "destination"
              );
            }
            this.$refs.orderMap.setMapZoom(8);
          }
        }, 100);

        setTimeout(() => {
          clearInterval(interval);
        }, 1000);
      }
    },
    getConsigneeOrderAttachment(id) {
      bus.$emit("showLoader", true);
      this.$api.consigneeManagement
        .getConsigneeOrderAttachment(id)
        .then((res) => {
          bus.$emit("showLoader", false);
          let generatedPDFBlob = new Blob([res.data], {
            type: "application/pdf",
          });
          var pdfUrl = URL.createObjectURL(generatedPDFBlob);
          window.open(pdfUrl);
        })
        .catch((error) => {
          bus.$emit("showLoader", false);
          console.error(error);
        });
    },
    getOrderDetails() {
      bus.$emit("showLoader", true);
      this.$api.consigneeManagement
        .getConsigneeOrderDetails(this.$route.query.id)
        .then((res) => {
          this.orderDetails = res.data;
          this.setOrderLocationOnMap(res.data);
          if (
            this.orderDetails &&
            (this.orderDetails.driver_contact_number ||
              this.orderDetails.driver_name ||
              this.orderDetails.vehicle_number)
          )
            this.orderDetails.driver_details = {
              contact_number: this.orderDetails?.driver_contact_number,
              full_name: this.orderDetails?.driver_name,
              vehicle: this.orderDetails?.vehicle_number,
            };
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getOrderItems(params = {}) {
      let payload = {
        id: this.$route.query.id,
        params: {
          ...params,
          limit: "all",
        },
      };
      bus.$emit("showLoader", true);
      this.$api.consigneeManagement
        .getConsigneeItemsList(payload)
        .then((res) => {
          this.itemList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getConsigneeOrderLogs(params = {}) {
      let payload = {
        id: this.$route.query.id,
        params: {
          ...params,
          limit: "all",
        },
      };

      bus.$emit("showLoader", true);
      this.$api.consigneeManagement
        .getConsigneeOrderLogs(payload)
        .then((res) => {
          this.orderLogs = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this.getOrderDetails();
      this.getOrderItems();
      this.getConsigneeOrderLogs();
    }
  },
};
</script>
